import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "timeline-item" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-line w-40px" }, null, -1)
const _hoisted_3 = { class: "timeline-icon symbol symbol-circle symbol-40px" }
const _hoisted_4 = { class: "symbol-label bg-light" }
const _hoisted_5 = { class: "svg-icon svg-icon-2 svg-icon-gray-500" }
const _hoisted_6 = { class: "timeline-content mb-10 mt-n1" }
const _hoisted_7 = { class: "pe-3 mb-5" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bold mb-2" }, " 3 new application design concepts added: ", -1)
const _hoisted_9 = { class: "d-flex align-items-center mt-1 fs-6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted me-2 fs-7" }, "Created at 4:23 PM by", -1)
const _hoisted_11 = {
  class: "symbol symbol-circle symbol-25px",
  "data-bs-toggle": "tooltip",
  "data-bs-boundary": "window",
  "data-bs-placement": "top",
  title: "Marcus Dotson"
}
const _hoisted_12 = ["alt"]
const _hoisted_13 = { class: "overflow-auto pb-5" }
const _hoisted_14 = { class: "d-flex align-items-center border border-dashed border-gray-300 rounded min-w-700px p-7" }
const _hoisted_15 = { class: "overlay me-10" }
const _hoisted_16 = { class: "overlay-wrapper" }
const _hoisted_17 = ["alt"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "overlay-layer bg-dark bg-opacity-10 rounded" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "btn btn-sm btn-primary btn-shadow"
  }, "Explore")
], -1)
const _hoisted_19 = { class: "overlay me-10" }
const _hoisted_20 = { class: "overlay-wrapper" }
const _hoisted_21 = ["alt"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "overlay-layer bg-dark bg-opacity-10 rounded" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "btn btn-sm btn-primary btn-shadow"
  }, "Explore")
], -1)
const _hoisted_23 = { class: "overlay" }
const _hoisted_24 = { class: "overlay-wrapper" }
const _hoisted_25 = ["alt"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "overlay-layer bg-dark bg-opacity-10 rounded" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "btn btn-sm btn-primary btn-shadow"
  }, "Explore")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_inline_svg, {
            src: "/media/icons/duotune/art/art005.svg",
            "aria-hidden": "true"
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("img", {
              src: "/media/avatars/150-3.jpg",
              alt: _ctx.translate('FACE_OF_A_PERSON')
            }, null, 8, _hoisted_12)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("img", {
                alt: _ctx.translate('III_PLUS_LOGO'),
                class: "rounded w-200px",
                src: "/media/valored/iii_logo.png"
              }, null, 8, _hoisted_17)
            ]),
            _hoisted_18
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("img", {
                alt: _ctx.translate('FACE_OF_A_PERSON'),
                class: "rounded w-200px",
                src: "/media/valored/iii_logo.png"
              }, null, 8, _hoisted_21)
            ]),
            _hoisted_22
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("img", {
                alt: _ctx.translate('FACE_OF_A_PERSON'),
                class: "rounded w-200px",
                src: "/media/valored/iii_logo.png"
              }, null, 8, _hoisted_25)
            ]),
            _hoisted_26
          ])
        ])
      ])
    ])
  ]))
}